import { render, staticRenderFns } from "./base-col.vue?vue&type=template&id=91f1cc2c"
import script from "./base-col.vue?vue&type=script&lang=js"
export * from "./base-col.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports